<template>
  <div class="phases">
    <div :style="{ display: (!step || step == 1) ? 'block' : 'none' }">
      <phase-item
        :phase-data="phase1"
        :color-1="5"
        :color-2="4"
      >
        <template #title>1ª Fase</template>
        <template #step-link>
          <router-link
            :to="{ name: 'confined-spaces-action-plan-form', params: { step: 1 } }"
            class="btn btn-success no-print"
            >Ver</router-link
          >
        </template>
        <template #description>
          <div><b>RISCOS:</b> MUITO ALTO e ALTO</div>
        </template>
      </phase-item>
    </div>

    <div :style="{ display: (!step|| step == 2) ? 'block' : 'none' }">
      <phase-item
        :phase-data="phase2"
        :color-1="3"
        :color-2="2"
        :show-footer="true"
      >
        <template #title>2ª Fase</template>
        <template #step-link>
          <router-link
            :to="{ name: 'confined-spaces-action-plan-form', params: { step: 2 } }"
            class="btn btn-success no-print"
            >Ver</router-link
          >
        </template>
        <template #description>
          <div><b>RISCOS:</b> MÉDIO E BAIXO</div>
        </template>
      </phase-item>
    </div>

    <div :style="{ display: (!step|| step == 3) ? 'block' : 'none' }">
      <phase-item
        :phase-data="phase3"
        :color-1="1"
        :show-footer="true"
      >
        <template #title>3ª Fase</template>
        <template #step-link>
          <router-link
            :to="{ name: 'confined-spaces-action-plan-form', params: { step: 3 } }"
            class="btn btn-success no-print"
            >Ver</router-link
          >
        </template>
        <template #description>
          <div><b>RISCO:</b> MUITO BAIXO</div>
        </template>
      </phase-item>
    </div>
  </div>
</template>

<script>
  import { computed } from '@vue/runtime-core'

  import PhaseItem from './PhaseItem'
  import { useStore } from 'vuex'

  export default {
    setup() {
      const store = useStore()
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)

      return {
        selected_order_of_service,
      }
    },
    components: {
      PhaseItem,
    },
    props: {
      filters: {
        type: Object,
        required: true,
        default: () => {},
      },
      step: {
        type: Number,
        required: false,
        default: 0,
      }
    },
    data() {
      return {
        phase1: {
          total: 0,
          delegated: 0,
          delegatedPercentage: 0,
          scheduled: 0,
          scheduledPercentage: 0,
          budgted: 0,
          budgtedPercentage: 0,
          projected: 0,
          projectedPercentage: 0,
          inAdequacy: 0,
          inAdequacyPercentage: 0,
          concluded: 0,
          concludedPercentage: 0,
          homologated: 0,
          homologatedPercentage: 0,
        },
        phase2: {
          total: 0,
          delegated: 0,
          delegatedPercentage: 0,
          scheduled: 0,
          scheduledPercentage: 0,
          budgted: 0,
          budgtedPercentage: 0,
          projected: 0,
          projectedPercentage: 0,
          inAdequacy: 0,
          inAdequacyPercentage: 0,
          concluded: 0,
          concludedPercentage: 0,
          homologated: 0,
          homologatedPercentage: 0,
        },
        phase3: {
          total: 0,
          delegated: 0,
          delegatedPercentage: 0,
          scheduled: 0,
          scheduledPercentage: 0,
          budgted: 0,
          budgtedPercentage: 0,
          projected: 0,
          projectedPercentage: 0,
          inAdequacy: 0,
          inAdequacyPercentage: 0,
          concluded: 0,
          concludedPercentage: 0,
          homologated: 0,
          homologatedPercentage: 0,
        },
      }
    },
    methods: {
      loadData(filters) {
        const queryString = this.getQueryString(filters)

        this.axios
          .get(
            `/api/action-plan/get-total-by-phase/?&confined_space=1&order_of_service_id=${this.selected_order_of_service.id}${queryString}`,
          )
          .then(({ data }) => {
            this.phase1 = { ...data.phase1 }
            this.phase2 = { ...data.phase2 }
            this.phase3 = { ...data.phase3 }
          })
          .catch((error) => {
            console.log(error)
          })
      },

      getQueryString(filters) {
        let query = ''

        if (filters) {
          const queryStringFilters = Object.keys(filters)
            .filter((key) => filters[key])
            .map((key) => key + '=' + filters[key])
            .join('&')
          query += `&${queryStringFilters}`
        }
        return query
      },

      onFilter(filters) {
        this.loadData(filters)
      },
    },
    mounted() {
      this.loadData()
    },
    watch: {
      selected_order_of_service() {
        this.loadData()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .phases {
    display: flex;
    justify-content: space-between;
  }
</style>
